import { useContext, useState } from 'react';
import StandardizedDataTable from '../../PrimeAids/StandardizedDataTable';
import { ReportContext } from '../../../context/ReportContext';
import { dataRollUp } from '../../PlotlyAids/dataRollUps';
import { formatDateToIsoExtDate, userColumns } from '../../../helpers';
import ReportLineChart from '../../PlotlyAids/ReportLineChart';
import ReportChartLayoutWrapper from '../../PlotlyAids/ReportChartLayoutWrapper';
import ExpandableInfoCard, {
    ExpandableInfoCardDescription,
    ExpandableInfoCardDetail,
} from '../../Cards/ExpandableInfoCard';

export const userFeedbackColumns = [
    { field: 'feedbackDatetime', name: 'Date ({tz} time zone)', dataType: 'datetime' },
    {
        field: 'feedbackType',
        name: 'Feedback',
        dataType: 'multiselect',
        styles: { minWidth: '20rem' },
    },
    {
        field: 'sentimentScore',
        name: 'Sentiment Score (-1 to 1)',
        dataType: 'numeric',
    },
    { field: 'resourceType', name: 'Resource', dataType: 'multiselect' },
    {
        field: 'resourceTitle',
        name: 'Title',
        dataType: 'multiselect',
        styles: { minWidth: '20rem' },
    },
    {
        field: 'freeFormFeedback',
        name: 'Additional Feedback',
        dataType: 'string',
        styles: { minWidth: '40rem' },
    },
];

const UserFeedback = () => {
    const { reportData } = useContext(ReportContext);

    const columns = [...userColumns, ...userFeedbackColumns];

    const [filteredData, setFilteredData] = useState([]);

    // const rolledUp = dataRollUp(
    //     filteredData,
    //     (row) => formatDateToIsoExtDate(row.feedbackDatetime),
    //     {
    //         count: true,
    //     }
    // );

    // const chartData = [
    //     {
    //         name: 'Total Feedback',
    //         x: rolledUp.map((x) => x.groupByField),
    //         y: rolledUp.map((x) => x.count),
    //     },
    // ];

    return (
        <div className="space-y-6">
            <StandardizedDataTable
                data={reportData}
                columns={columns}
                onValueChange={setFilteredData}
            />
            {/* <ReportChartLayoutWrapper>
                <ReportLineChart
                    data={chartData}
                    chartTitle="User Feedback Over Time"
                />
            </ReportChartLayoutWrapper> */}

            <ExpandableInfoCard title="What is this data?">
                <ExpandableInfoCardDescription>
                    This report shows detailed user feedback collected from interactions
                    with various resources and features. Each row represents a single
                    feedback submission. This feedback is sourced from multiple areas
                    across the site including a prompt at the bottom of content, a
                    freeform field for areas the user needs help with from the Financial
                    Wellness Checkup, and a modal for providing feedback about the
                    platform as a whole.
                </ExpandableInfoCardDescription>
                <ExpandableInfoCardDetail name="Date">
                    When the feedback was submitted.
                </ExpandableInfoCardDetail>
                <ExpandableInfoCardDetail name="Feedback">
                    The type of feedback provided.
                </ExpandableInfoCardDetail>
                <ExpandableInfoCardDetail name="Sentiment Score (-1 to 1)">
                    AI-analyzed sentiment of the feedback, ranging from -1 (negative) to 1
                    (positive).
                </ExpandableInfoCardDetail>
                <ExpandableInfoCardDetail name="Resource">
                    The type of resource or feature that the feedback relates to (if
                    applicable).
                </ExpandableInfoCardDetail>
                <ExpandableInfoCardDetail name="Title">
                    The specific title or name of the resource that was rated (if
                    applicable).
                </ExpandableInfoCardDetail>
                <ExpandableInfoCardDetail name="Additional Feedback">
                    Free-form text feedback provided by the user with additional comments
                    or details.
                </ExpandableInfoCardDetail>
            </ExpandableInfoCard>
        </div>
    );
};

export default UserFeedback;
